import React, { Component } from "react";
import "./App.css";
import { SPACES, TARGETS, TARGET_WATCHES } from "./config";
const BILLIE_JEAN = require("./billie_jean.mp3");

const EXECUTED_TASKS = {};

const INITIAL_PRINT = [
  "This is The Office Adventure. Can you survive and help your colleagues to survive a day at the office?",
  "",
  "You arrive at the office from the main door at 8:00 AM. It looks quiet in here...",
];

const ConsoleRow = ({ text }) =>
  text.length ? <span className="console-row">{text}</span> : <br />;

class App extends Component {
  constructor() {
    super();

    const time = new Date();
    time.setHours(8);
    time.setMinutes(0);
    this.state = {
      time,
      print: [],
      input: "",
      currentSpace: "lobby",
      currentTasks: [],
      isGameEnded: false,
    };

    this.inputRef = React.createRef();
  }

  componentDidMount = () => {
    this.setFocus();
    this.setPrintAndTasks(this.state.currentSpace, INITIAL_PRINT);
  };

  getValidNextSpaces = (space) => {
    const { time } = this.state;
    return space.nextSpaces.filter((item) => {
      if (!item.condition) return true;
      const hoursValid =
        !item.condition.hours ||
        item.condition.hours < time.getHours() ||
        (item.condition.hours === time.getHours() &&
          item.condition.minutes <= time.getMinutes());
      const targetValid =
        !item.condition.target ||
        TARGETS[item.condition.target].value === item.condition.value;
      return hoursValid && targetValid;
    });
  };

  setFocus = () => {
    if (!this.state.isGameEnded) this.inputRef.current.focus();
  };

  setPrintAndTasks = (nextSpace, overrideText, watchTexts) => {
    const print = [];
    const space = SPACES[nextSpace];
    if (overrideText) {
      print.push(...overrideText);
    } else {
      const { texts } = space;
      print.push(texts[Math.floor(Math.random() * texts.length)]);
    }
    print.push("");

    if (watchTexts && watchTexts.length) {
      print.push(...watchTexts, "");
    }

    print.push(`You are at the ${space.name}. What would you like to do?`);

    // Tasks
    const tasks = space.tasks
      ? space.tasks.filter(
          (task) =>
            (!task.condition ||
              TARGETS[task.condition.target].value === task.condition.value) &&
            !(task.text in EXECUTED_TASKS)
        )
      : [];
    tasks.forEach((task, index) => print.push(`${index + 1}: ${task.text}`));
    this.setState({ currentTasks: tasks });

    // Moving
    this.getValidNextSpaces(space).forEach((item, index) =>
      print.push(`${tasks.length + index + 1}: Go to ${SPACES[item.name].name}`)
    );
    this.setState({ print });
  };

  checkEnding = (overrideTexts) => {
    let print;
    const targetValues = Object.values(TARGETS);
    const tasksCompleted =
      targetValues.filter((value) => value.value).length ===
      targetValues.length;
    if (tasksCompleted) {
      print = [
        "It looks that everything is done for today. I'm going home. Tomorrow will be another great adventure!",
        "",
        "You are a true hero.",
      ];
    } else {
      print = overrideTexts
        ? overrideTexts
        : [
            "Going home already? An uncomfortable feeling shivers down the spine... Did I really give my everything today?",
          ];
      print.push(...["", "Refresh the page to try again."]);
    }
    this.setState({ print, isGameEnded: true });
  };

  onInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const { time, input, currentTasks } = this.state;
    const currentSpace = SPACES[this.state.currentSpace];
    const index = Number.parseInt(input, 10);
    const nextSpaces = this.getValidNextSpaces(currentSpace);
    if (
      !Number.isNaN(index) &&
      index >= 1 &&
      index <= currentTasks.length + nextSpaces.length
    ) {
      const newTime = new Date(time.getTime() + 15 * 60000);
      this.setState({ time: newTime });
      const watchTexts = TARGET_WATCHES.filter(
        (item) =>
          item.hours <= newTime.getHours() &&
          item.minutes <= newTime.getMinutes() &&
          (!item.target || TARGETS[item.target].value !== item.value) &&
          !item.shown
      ).map((item) => {
        item.shown = true;
        return item.text;
      });

      if (index <= currentTasks.length) {
        const task = currentTasks[index - 1];
        if (task.effects) {
          task.effects.forEach(
            (effect) => (TARGETS[effect.target].value = effect.value)
          );
        }
        EXECUTED_TASKS[task.text] = true;
        this.setPrintAndTasks(
          this.state.currentSpace,
          [task.resultText],
          watchTexts
        );
      } else {
        const nextSpace = nextSpaces[index - currentTasks.length - 1].name;
        if (nextSpace === "exit") {
          TARGETS.finishIt.value = true;
          this.checkEnding();
        } else {
          this.setState({ currentSpace: nextSpace });
          this.setPrintAndTasks(nextSpace, undefined, watchTexts);
        }
      }

      const failedTargets = Object.values(TARGETS).filter(
        (target) =>
          target.deadline &&
          !target.value &&
          target.deadline.hours <= time.getHours() &&
          target.deadline.minutes <= time.getMinutes()
      );
      if (failedTargets.length)
        this.checkEnding(failedTargets.map((target) => target.deadline.text));
    }

    this.setState({ input: "" });
  };

  render() {
    const { time, print, input, isGameEnded } = this.state;
    console.log(
      Object.entries(TARGETS).filter(([key, target]) => !target.value)
    );

    return (
      <div className="app" onClick={this.setFocus}>
        <div className="clock">
          <span>
            {("0" + time.getHours()).slice(-2)}:
            {("0" + time.getMinutes()).slice(-2)}
          </span>
        </div>
        {print.map((row, index) => (
          <ConsoleRow key={index} text={row} />
        ))}
        {!isGameEnded && (
          <form onSubmit={this.onSubmit}>
            <input
              ref={this.inputRef}
              className="input"
              type="text"
              value={input}
              onChange={this.onInputChange}
            />
          </form>
        )}
        {TARGETS.playMusic.value && <audio src={BILLIE_JEAN} autoPlay />}
      </div>
    );
  }
}

export default App;
